import { render, staticRenderFns } from "./LocationRegistrationForm.vue?vue&type=template&id=1089731f&scoped=true&"
import script from "./LocationRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./LocationRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationRegistrationForm.vue?vue&type=style&index=0&id=1089731f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089731f",
  null
  
)

export default component.exports